// import React from 'react'
// import { TypeAnimation } from 'react-type-animation'



// const Forname = () => {
//     const textSequence = ["Full Stack Developer",
//     "Web Developer",
    
//     "Backend Developer",
//     "Coder"];
//   return (

//     <div>
//           <TypeAnimation
//                     sequence={[textSequence[0], 1000, ""]}
//                     repeat={Infinity}
//                     cursor={true}
                
//                     style = {
//                         {
//                             whiteSpace: "pre-line",
//                             display:"block",
//                             color: `yellow`,                  
//                         }
//                     }
//                     // omitDeletionAnimation={true}
//                 />


//     </div>
//   )
// }

// export default Forname

import React from 'react';
import { TypeAnimation } from 'react-type-animation';

const Forname = () => {
  const textSequence = [
    "Full Stack Developer",
    "Web Developer",
    "Backend Developer",
    "Coder"
  ];

  return (
    <div>
      <TypeAnimation
        sequence={[
          ...textSequence, // Add each text string to the sequence
          1500,            // Duration to display each text string (in milliseconds)
        ]}
        wrapper="span"      // You can change the wrapper element if needed
        speed={20}          // Adjust the typing speed (lower is faster)
        repeat={Infinity}  // Loop indefinitely
        cursor={true}      // Show cursor
        style={{
          whiteSpace: "pre-line",
          display: "inline", // Changed to inline to avoid breaking line
          color: "yellow",
        }}
      />
    </div>
  );
}

export default Forname;
